<script>
  export let title = "";
  export let subtitle = "";
</script>

<div class="settings">
  <div>
    <div class="title">{title}</div>
    <div class="subtitle">{@html subtitle}</div>
  </div>
  <slot name="content" />
</div>

<style>
  .settings {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--t-c);
    border-bottom: 1px solid #d0d0d2;
    justify-content: space-between;
    padding: 1em 0;
  }

  .title {
    font-weight: 400;
    font-size: 16px;
  }
  .subtitle {
    font-weight: 400;
    font-size: 14px;
    color: var(--t-c-l);
    max-width: 35ch;
  }

  @media (max-width: 450px) {
    .settings {
      display: block;
      padding: 0.5em 0;
    }
  }
</style>
